const CHUNK_ERROR_PATTERNS = [
  /Couldn't resolve component/i,
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /Unable to preload/i
]

const isChunkError = (error: unknown) => {
  const message = error instanceof Error ? error.message : String(error ?? '')
  return CHUNK_ERROR_PATTERNS.some((pattern) => pattern.test(message))
}

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()

  // Schlägt der Chunk beim ersten Rendern fehl, unterdrückt Nuxt den
  // vite:preloadError und vue-router wirft stattdessen
  // "Couldn't resolve component". Diesen Fall selbst abfangen und
  // die App neu laden (reloadNuxtApp hat einen eigenen Loop-Schutz).
  router.onError((error, to) => {
    if (isChunkError(error)) {
      reloadNuxtApp({ path: to.fullPath, persistState: true })
    }
  })

  nuxtApp.hook('vue:error', (error) => {
    if (isChunkError(error)) {
      reloadNuxtApp({ path: router.currentRoute.value.fullPath, persistState: true })
    }
  })
})
